export { default } from "./EntityMenu";
